import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useWmgSession } from '~/modules/auth/hooks/useWmgSession';

import { DealOwnerQueryKeys } from '../config/queryKeys';
import { getRequestHeaders } from '../lib/headers';
import { LegacyCoopClient } from '../lib/LegacyCoopClient';
import type { DealOwnerListResponse } from '../lib/schemas';
import { DealOwnerListResponseSchema } from '../lib/schemas';
import type { PresetUseQueryOptions } from '../lib/types';

export function useDealOwnerList<TData = DealOwnerListResponse>(
  options?: PresetUseQueryOptions<DealOwnerListResponse, TData>,
) {
  const { token } = useWmgSession();

  const { data, ...query } = useQuery({
    queryKey: DealOwnerQueryKeys.list(),
    queryFn: async () => {
      const responseData = await LegacyCoopClient.get(
        'dictionaries/deal-owner-options',
        {
          headers: getRequestHeaders(token),
        },
      ).json();

      return DealOwnerListResponseSchema.parse(responseData);
    },
    placeholderData: keepPreviousData,
    ...options,
  });

  return { dealOwnerList: data, ...query };
}
